module.exports = __webpack_public_path__ + "static/pic04-64e8ccf2b6e7cfd3e5cce15b1e0e899d.jpg";